import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    defaultMessage: 'Request Submitted',
    id: '7RJucF',
    description: 'Title of the success modal',
  },
  primaryMessage: {
    defaultMessage: "We've Received Your Request",
    id: '4IYGKr',
    description: 'Primary success message displayed in the modal',
  },
  secondaryMessage: {
    defaultMessage: 'An expert will reach out within the next business day to schedule a call.',
    id: 'ZMWuRA',
    description: 'Secondary message explaining next steps',
  },
  doneButton: {
    defaultMessage: 'Done',
    id: 'S8ojI+',
    description: 'Button text to close the success modal',
  },
  successIconAlt: {
    defaultMessage: 'Success',
    id: 'gM7FDW',
    description: 'Alt text for the success icon image',
  },
});
